import React from 'react';
import './PatentUpgradeModal.css';

const PatentUpgradeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleUpgrade = () => {
    window.location.href = '/dashboard/billing';
  };

  return (
    <div className="patent-upgrade-modal-overlay" onClick={onClose}>
      <div className="patent-upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <button className="patent-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="patent-modal-icon">
          🔒
        </div>

        <h2 className="patent-modal-title">Interested to learn more about Patents?</h2>

        <p className="patent-modal-description">
          Access full patent information, detailed documents, and direct links with our Pro Plan.
        </p>

        <div className="patent-modal-features">
          <div className="patent-feature">
            <span className="patent-feature-icon">✓</span>
            <span>Unlimited patent access</span>
          </div>
          <div className="patent-feature">
            <span className="patent-feature-icon">✓</span>
            <span>Full document downloads</span>
          </div>
          <div className="patent-feature">
            <span className="patent-feature-icon">✓</span>
            <span>Direct links to patent sources</span>
          </div>
        </div>

        <button className="patent-modal-upgrade-btn" onClick={handleUpgrade}>
          Upgrade to Pro Plan
        </button>

        <button className="patent-modal-cancel-btn" onClick={onClose}>
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default PatentUpgradeModal;
